import { useEffect, createContext, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Shipments, Login, Home } from "./pages";
export const RunnerContext = createContext();
export default function Main() {
  const navigate = useNavigate();
  const [runnerData, setRunnerData] = useState(() => {
    const storedRunnerData = localStorage.getItem("runnerData");
    return storedRunnerData ? JSON.parse(storedRunnerData) : null;
  });

  useEffect(() => {
    console.log("runnerData", runnerData);
  }, [runnerData]);
  useEffect(() => {
    if (!runnerData) {
      navigate("/login");
    }
  }, [runnerData, navigate]);

  return (
    <RunnerContext.Provider value={{ runnerData, setRunnerData }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/scan-shipments" element={<Shipments />} />
      </Routes>
    </RunnerContext.Provider>
  );
}
